/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import axios from "axios";
import { Modal, ModalOverlay, ModalContent, ModalBody } from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from "@chakra-ui/react";

const UserUpdateTwoFactorStatusConfirmModal: React.FC<{
  setSwalProps: any;
  triggerReload(): void;
  isOpen: boolean;
  onClose(): void;
  userToUpdate: any;
  statusToUpdate: any;
}> = ({
  setSwalProps,
  triggerReload,
  isOpen,
  onClose,
  userToUpdate,
  statusToUpdate,
}) => {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const userRole = localStorage.getItem("userRole")?.toLowerCase();
  const sysUsername = localStorage.getItem("username")?.toLowerCase();

  const closeModal = () => {
    onClose();
  };

  const handleSubmit = async () => {
    setIsProcessing(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/${userRole}/user/action/user-update-two-factor-status`, {
        userRole: userRole,
        sysUsername: sysUsername,
        subaccountId: null,
        username: userToUpdate.username,
        statusToUpdate: statusToUpdate
      });

      // Close modal first, then show success message
      setIsProcessing(false);
      onClose();

      setSwalProps({
        show: true,
        icon: "success",
        title: "Success",
        html: `User two-factor authentication has been ${
          statusToUpdate === "enabled" ? "enabled" : "disabled"
        }`,
        showConfirmButton: true,
        didClose: () => {
          setSwalProps({});
          triggerReload();
        },
      });
    } catch (error: any) {
      setIsProcessing(false);
      console.error("Error proceeding:", error.response.data);
      setSwalProps({
        show: true,
        icon: "error",
        title: "Oops!",
        html: "Two-factor update status failed. Please try again or contact support",
        showConfirmButton: true,
        didClose: () => {
          setSwalProps({});
        },
      });
    }
  };

  return (
    <>
      {userToUpdate && (
        <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
          <ModalOverlay className="bg-[#000] !opacity-30" />
          <ModalContent className="dark:!bg-neutral-900 !z-[1002] !m-auto !w-full max-w-xl !rounded-2xl !border !border-gray-200 !bg-white !shadow-xl dark:!border-white/10 md:!top-[12vh]">
            <ModalBody className="p-6 md:p-7">
              <div className="mb-4 flex items-start gap-3">
                <div className="rounded-xl bg-primary-50 p-2 text-primary-600 ring-1 ring-primary-100 dark:bg-primary-900/20 dark:text-primary-400 dark:ring-primary-900/30">
                  <svg
                    viewBox="0 0 24 24"
                    className="h-5 w-5"
                    fill="currentColor"
                  >
                    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
                    Update Two-Factor Authentication
                  </h1>
                  <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
                    {statusToUpdate === "enabled" ? "Enable" : "Disable"} 2FA for this user
                  </p>
                </div>
              </div>

              <div className="mb-4 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-800 dark:border-blue-900/40 dark:bg-blue-900/20 dark:text-blue-300">
                Are you sure you want to <span className="font-semibold capitalize">{statusToUpdate}</span> <span className="font-semibold">Two-Factor Authentication</span> for this user?
              </div>

              <div className="dark:bg-neutral-800/50 mb-6 rounded-xl bg-gray-50 p-4 ring-1 ring-gray-100 dark:ring-white/10">
                <div className="flex flex-col gap-3 text-sm">
                  <div className="flex">
                    <div className="w-28 shrink-0 text-gray-700 dark:text-gray-400">
                      Email
                    </div>
                    <div className="font-medium text-gray-900 dark:text-white">
                      {userToUpdate.email}
                    </div>
                  </div>

                  <div className="flex">
                    <div className="w-28 shrink-0 text-gray-700 dark:text-gray-400">
                      Username
                    </div>
                    <div className="font-medium text-gray-900 dark:text-white">
                      {userToUpdate.username}
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-end gap-2">
                <Button
                  onClick={closeModal}
                  isDisabled={isProcessing}
                  className="dark:bg-neutral-900 dark:hover:bg-neutral-800 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500/20 dark:border-white/10 dark:text-white"
                >
                  Cancel
                </Button>

                <Button
                  onClick={handleSubmit}
                  isDisabled={isProcessing}
                  isLoading={isProcessing}
                  loadingText="Processing..."
                  className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/30 disabled:cursor-not-allowed disabled:bg-gray-400"
                >
                  Update user
                </Button>
              </div>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default UserUpdateTwoFactorStatusConfirmModal;